<template lang="pug">
v-container(fluid pa-0 ma-0 class="widget-container d-flex align-self-stretch tw-relative ")
  v-row(no-gutters align="stretch" justify="center" class=" tw-cursor-pointer tw-flex tw-h-full " @click="edit")
    v-col(class=" tw-w-full tw-h-full tw-p-0  ")
      v-hover(v-slot="{ hover }")
        div(class="tw-w-full tw-h-full tw-grid tw-grid-cols-12 tw-m-0")
          v-fade-transition
            div(
              v-if="hover"
              class=" transition-fast-in-fast-out tw-z-20 tw-col-span-12 tw-h-full tw-align-middle  tw-row-span-full tw-col-start-1 "
            )
              div(class="tw-w-full tw-h-full tw-grid tw-grid-cols-12 tw-m-0 ")
                div(class="tw-z-10 tw-col-span-12 tw-h-full tw-align-middle  tw-row-span-full tw-col-start-1 ")
                  div(class="tw-h-full tw-justify-center tw-items-center  tw-flex ")
                    v-btn(dark elevation="0" fab color="grey darken-3")
                      v-icon(dark) mdi-pencil
                div(class=" tw-row-span-full tw-col-start-1 tw-col-span-12 tw-bg-white tw-opacity-25 ")

          div(class=" tw-row-span-full tw-col-start-1 tw-col-span-12")
            div(v-if="content" class="tw-z-0 tw-w-full tw-h-full tw-px-6 tw-py-10")
              v-row(no-gutters align="center" justify="center")
                v-col(cols="10")
                  div(v-dompurify-html="content")
            div(v-else)
              v-row(no-gutters align="center" justify="center" class="tw-px-6 tw-py-10")
                v-col(cols="10")
                  span(class="tw-text-3xl tw-font-bold") Description
  //Edit dialog
  v-dialog(
    v-model="editScreen"
    persistent
    no-click-animation
    max-width="65%"
    hide-overlay
    class="tw-ml-32"
  )
    v-card(class="tw-overflow-hidden")
      v-card-text(class="tw-mt-10")
        kubiqa-misc-editor(
          :page="page"
          :gallery="gallery"
          :placement="widget.placement"
          :key="key"
          ref="editor"
          @close="editScreen = false"
          @loading="(status) => (loading = status)"
        )
      v-card-actions(align="right")
        v-row(justify="end")
          v-col(cols="auto")
            v-btn(@click="cancel" :disabled="loading" text color="black") Cancel
          v-col(cols="auto")
            v-btn(depressed @click="save" :loading="loading" color="rgba(94,129,244,0.80)")
              span(class="tw-font-bold") SAVE
</template>

<script>
export default {
  data() {
    return {
      editScreen: false,
      loading: false,
      key: 1,
      widget: {
        content: null,
        placement: 'description',
      },
    };
  },
  computed: {
    page() {
      return this.$store.getters['website/website'].pages.buy;
    },
    gallery() {
      return this.$store.getters['website/website'].gallery;
    },
    widgets() {
      if (typeof this.page.widgets !== 'undefined') {
        return this.page.widgets;
      } else {
        return null;
      }
    },
    content() {
      if (typeof this.widgets.description !== 'undefined') {
        return this.widgets.description.content;
      } else {
        return null;
      }
    },
  },
  mounted() {
    this.widget.content = this.content;
  },
  methods: {
    edit() {
      this.key++;
      return (this.editScreen = true);
    },
    cancel() {
      return (this.editScreen = false);
    },
    save() {
      this.$refs.editor.save();
    },
  },
};
</script>
